import React from "react"; // ← wichtig für TS + isolatedModules

export type Participant = {
  user_id: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
};

interface Props {
  participants: Participant[];
  selected: string[];
  setSelected: (ids: string[]) => void;
  distributeToAll: boolean;
  setDistributeToAll: (value: boolean) => void;
}

export default function ParticipantSelector({
  participants,
  selected,
  setSelected,
  distributeToAll,
  setDistributeToAll,
}: Props) {
  const toggleSelection = (userId: string) => {
    if (selected.includes(userId)) {
      setSelected(selected.filter((id) => id !== userId));
    } else {
      setSelected([...selected, userId]);
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2">Verteilen auf</label>
      <div className="flex items-center gap-4 mb-2">
        <label className="flex items-center gap-1">
          <input
            type="radio"
            checked={distributeToAll}
            onChange={() => {
              setDistributeToAll(true);
              setSelected(participants.map((p) => p.user_id));
            }}
          />
          Alle
        </label>
        <label className="flex items-center gap-1">
          <input
            type="radio"
            checked={!distributeToAll}
            onChange={() => {
              setDistributeToAll(false);
              setSelected([]);
            }}
          />
          Ausgewählte
        </label>
      </div>

      {!distributeToAll && (
        <div className="space-y-1 pl-2">
          {participants.map((p) => {
            const name =
              `${p.first_name ?? ""} ${p.last_name ?? ""}`.trim() || p.email;
            return (
              <label key={p.user_id} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={selected.includes(p.user_id)}
                  onChange={() => toggleSelection(p.user_id)}
                />
                {name}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
